import React, {PureComponent} from "react";
import {BenefitEntity} from "../../data/entities/ProgressionLevelEntity";
import giftIcon from "../../resources/icons/icon-gift.svg";
import {UserProgressionInfoEntity} from "../../data/entities/UserProgressionInfoEntity";
import {FormattedMessage, FormattedPlural} from "react-intl";

interface Props {
    userProgressionInfo: UserProgressionInfoEntity;
}

export default class CurrentUserProgressionLevel extends PureComponent<Props> {

    getBenefitIcon(benefit: BenefitEntity) {
        let icon = null;
        switch (benefit.typeId) {
            case 1:
                icon = giftIcon;
                break;
        }

        return (icon === null) ? null : <img src={icon} className={"benefitIcon"} alt=""/>;
    }

    render(): JSX.Element {

        let {currentProgressionLevel} = this.props.userProgressionInfo;
        let {consecutiveActiveMonths} = this.props.userProgressionInfo.subscriptionInfo

        if(typeof currentProgressionLevel == "undefined") {
            return (<React.Fragment />);
        }

        let rewardBenefit = currentProgressionLevel.benefits.find(benefit => benefit.typeId === 1);

        return (
            <ul className="currentProgressionLevel">
                <li>
                    {currentProgressionLevel.image &&
                        <img src={currentProgressionLevel.image} alt={currentProgressionLevel.name}/>
                    } {currentProgressionLevel.name}
                </li>
                {
                    (rewardBenefit && parseInt(rewardBenefit.value) > 0) &&
                        <li>
                            <React.Fragment>
                                {this.getBenefitIcon(rewardBenefit)} x <span className="highlight">{rewardBenefit.value}</span>
                            </React.Fragment>
                        </li>
                }
                <li>
                    {
                        consecutiveActiveMonths > 0 &&
                            <React.Fragment>
                                <FormattedMessage id="progression.level.subscribed_for" />: <span className="highlight">{consecutiveActiveMonths} </span>
                                <FormattedPlural
                                one={<FormattedMessage id="general.date.month" />}
                                other={<FormattedMessage id="general.date.months" />}
                                value={consecutiveActiveMonths}
                                />
                            </React.Fragment>
                    }
                    {
                        consecutiveActiveMonths === 0 &&
                            <FormattedMessage id="progression.level.new_subscriber" />
                    }
                </li>
            </ul>
        );
    }
}